'use client';

export { default } from './Tab';
export { default as tabClasses } from './tabClasses';
export * from './tabClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Tab/index.js
// module id = 889
// module chunks = 22